<template>
    <ies-form-field :field="field">
        <tinymce
                :init="configuration.init"
                v-model="input"
                :id="tinyId"
                :name="this.field.fieldName"
                :required="this.field.required"
                v-on:keyup="updateField()"
        >
            {{ this.field.value }}
        </tinymce>
    </ies-form-field>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue';

    export default {

        name: 'ies-input-tinymce',
        props: ['field'],
        components: {
            'tinymce': Editor,
            'ies-form-field': require('./FormField.vue').default,
        },
        data () {
            return {
                input: this.field.value,
                configuration: {
                    init: {
						selector: 'textarea',
                        license_key: 'gpl',
						remove_linebreaks: false,
                        plugins: 'advlist autolink lists link image charmap anchor searchreplace visualblocks code insertdatetime media contextmenu paste code',
                        toolbar: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                        setup: (editor) => {
							this.input = this.field.value;
                            editor.on('change', function () {
                                tinymce.triggerSave();
                            });
                        },
                    },
                }
            }
        },

		created: function() {

			var unformatted = this.field.value.indexOf('<') !== 0 && this.field.value !== '';

			var isList = this.field.value.indexOf('<ul>') === 0;
			if (!isList) {
				this.field.value = this.replaceLineBreaks(this.field.value);
			}
			if ( unformatted ) {
				this.field.value = '<p>' + this.field.value + '</p>';
			}
		},

        methods: {
			replaceLineBreaks: function(data) {
     			var replacedData = data.replaceAll("\r\n\r\n", "</p><p>");
				replacedData = data.replaceAll("\r\n", "<br>");
     			return replacedData;
			},
            updateField: function(){
                this.field.value = this.input;
            }
        },

        computed: {
            tinyId() {
                return 'tinymce_' + this.field.fieldName;
            },
        },
        watch: {
            input: {
                handler: function() {
                    this.updateField();
                }
            }
        }
    }
</script>


